import { render, staticRenderFns } from "./Turnstile.vue?vue&type=template&id=bc2e1c38&scoped=true"
import script from "./Turnstile.vue?vue&type=script&lang=js"
export * from "./Turnstile.vue?vue&type=script&lang=js"
import style0 from "./Turnstile.vue?vue&type=style&index=0&id=bc2e1c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e1c38",
  null
  
)

export default component.exports